import React, { createContext, useContext } from "react";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import "./App.css";

import Router from "./components/router";
import theme from "./assets/theme";
import useAuthState from "./services/hooks/useAuthState.hook";
import GlobalContext from "./state/GlobalContext";
import { transitions, positions, Provider as AlertProvider } from "react-alert";
import AlertTemplate from "react-alert-template-basic";

const AppContext = createContext();

export const AppContextProvider = AppContext.Provider;
export const AppContextConsumer = AppContext.Consumer;

const options = {
  position: positions.TOP_RIGHT,
  timeout: 4000,
  offset: "30px",
  transition: transitions.FADE,
  containerStyle: {
    zIndex: 9999
  }
};

function App() {
  const [user, init] = useAuthState();
  const { session } = useContext(GlobalContext);
  if (user !== null && !session.state.isLoggedIn && !init) {
    session.dispatch({
      type: "LOGIN",
      payload: { user }
    });
  }

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <AlertProvider template={AlertTemplate} {...options}>
        <MuiThemeProvider theme={theme}>
          <Router />
        </MuiThemeProvider>
      </AlertProvider>
    </MuiPickersUtilsProvider>
  );
}

export default App;
